// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8308dad9","container":"_398ee00d","image":"_74248a6d","title":"_5118196a"};